export default __webpack_public_path__ + "static/media/paymentAccept.ce3c44df.svg";